export var AvailabilityUntil;
(function (AvailabilityUntil) {
    AvailabilityUntil["SIX_MONTHS"] = "6-MONTH";
    AvailabilityUntil["ONE_YEAR"] = "1-YEAR";
    AvailabilityUntil["INDEFINITELY"] = "INDEFINITELY";
})(AvailabilityUntil || (AvailabilityUntil = {}));
//# sourceMappingURL=availabilityUntil.js.map